// extracted by mini-css-extract-plugin
export var active = "_du-7";
export var container = "_du-0";
export var evenWidth = "_du-4";
export var large = "_du-5";
export var outlet = "_du-8";
export var slide = "_du-2";
export var small = "_du-6";
export var tab = "_du-3";
export var tabs = "_du-1";